module.exports = __webpack_public_path__ + "static/media/nsw-vic-border-closure-news.fe5e4277.jpg";